import { createContext } from 'react';

// Responsible for storing the current locale (eg. nl-nl) to be
// used when in deeply nested places
export const LocaleContext = createContext({});
LocaleContext.displayName = 'LocaleContext';

export const LocaleContextProvider = LocaleContext.Provider;
export const LocaleContextConsumer = LocaleContext.Consumer;
